import request from '@/utils/request'

// 文案栏目
export function getShareList() {
    return request({
        url: '/agent/treatmentImages/list',
        method: 'get',
    })
}

// 文案详情
export function treatmentDetail(id) {
    return request({
        url: `/agent/treatmentImages/getById/${id}`,
        method: 'get',
    })
}

// 合成文案
export function treatmentComposite(id) {
    return request({
        url: `/agent/treatmentImages/composite/${id}`,
        method: 'post',
    })
}

// 文案列表
export function treatmentList(params) {
    return request({
        url: `/agent/treatmentImages/getByType`,
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/share.js